const OPEN_MANUAL_DIAL = 'opsmind:open-manual-dial';

/** Номер живёт только в памяти окна: открытие поля не запускает звонок. */
export function openManualDial(number: string) {
  window.dispatchEvent(new CustomEvent(OPEN_MANUAL_DIAL, { detail: number }));
}

export function subscribeManualDial(open: (number: string) => void) {
  const listener = (event: Event) => {
    const number: unknown = (event as CustomEvent<unknown>).detail;
    if (typeof number === 'string' && number.trim() !== '') open(number);
  };
  window.addEventListener(OPEN_MANUAL_DIAL, listener);

  return () => window.removeEventListener(OPEN_MANUAL_DIAL, listener);
}
